module.exports = __webpack_public_path__ + "static/media/kfc-24-50.cfc54dbd.jpg";